module.exports = __webpack_public_path__ + "img/clock-icon.bd7fcc7b.svg";